module.exports = {
      id: "gzsports-usage",
      viewBox: "0 0 17.95 23.898",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#gzsports",
      toString: function () {
        return this.url;
      }
    }